module.exports = "<div [ngClass]=\"fuseConfig.layout.navbar.primaryBackground\">\n    <fuse-navigation layout=\"horizontal\"></fuse-navigation>\n</div>"